<template>
  <div class="finance-invoice">
    <div class="applic-btn">
      <a-button type="primary" @click="applicInvoice">申请开票</a-button>
    </div>
    <div class="invoice-row">
      <a-row :gutter="20">
        <a-col :span="8">
          <div class="invoice-row__item">
            <div>
              <div class="item-icon">
                <a-icon type="pay-circle" />
              </div>
              <div class="item-content">
                <p>已开票金额（元）</p>
                <p>{{invoiceData.amounted}}</p>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="invoice-row__item">
            <div>
              <div class="item-icon">
                <a-icon type="property-safety" />
              </div>
              <div class="item-content">
                <p>按充值可开票金额（元）</p>
                <p>{{invoiceData.amounting}}</p>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="invoice-row__item">
            <div>
              <div class="item-icon">
                <a-icon type="money-collect" />
              </div>
              <div class="item-content">
                <p>按发放可开票金额（元）</p>
                <p>{{invoiceData.amounting2}}</p>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <search-box :data-source="searchData" :span="4" @handleSumbit="searchTableData" @reset="resetTables" style="margin-bottom: 10px;" />
    <card title="发票列表">
      <template slot="right">
        <a-button icon="file-add" @click="invoiceExport">{{exportLoading ? '导出中...' : '导出'}}</a-button>
      </template>
      <a-table row-key="uid" :loading="loading" :columns="columns" :data-source="invoiceData.infolist || []" :scroll="{ x: 1300 }" :pagination="false">
        <template slot="invoice_type" slot-scope="text">
          <span>{{text === 1 ? '增值税普通发票' : '增值税专用发票'}}</span>
        </template>
        <template slot="invoice_status" slot-scope="text">
          <span>{{status[text]}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link" @click="viewDetails(record)">查看详情</a-button>
        </template>
      </a-table>
      <div class="common-pagination">
        <a-pagination show-quick-jumper :default-current="requestParams.currentPage" :total="invoiceData.totalElement ? invoiceData.totalElement : 0" @change="onChange" />
      </div>
    </card>
    <a-modal :visible="visible" title="发票信息" :width="750" @cancel="onCancel">
      <template slot="footer">
        <a-button @click="onCancel">取消</a-button>
        <a-button class="modal-okbtn" type="primary" @click="addAppInvoice" :disabled="isDetails && currentInvoiceInfo.invoice_status !== 10" :loading="addLoading">{{isDetails ? '取消开票' : '确定'}}</a-button>
      </template>
      <div class="invoice-info-item">
        <h3>开票方</h3>
        <div class="info-item-content">
          <div class="content-row">
            <p class="content-row-name">名称：</p>
            <p>{{invoiceInfo.party_name}}</p>
          </div>
        </div>
      </div>
      <div class="invoice-info-item">
        <h3>发票抬头</h3>
        <div class="info-item-content">
          <div class="content-row">
            <p class="content-row-name">名称：</p>
            <p>{{invoiceInfo.enterpriseName}}</p>
          </div>
          <div class="content-row">
            <p class="content-row-name">纳税人识别号：</p>
            <p>{{invoiceInfo.identificatioNum}}</p>
          </div>
          <div class="content-row">
            <p class="content-row-name">注册地址 开票电话：</p>
            <p>{{invoiceInfo.address}} {{invoiceInfo.phoneNum}}</p>
          </div>
          <div class="content-row">
            <p class="content-row-name">开户行及账号：</p>
            <p>{{invoiceInfo.depositBank}} {{invoiceInfo.openAccount}}</p>
          </div>
          <div class="content-row">
            <p class="content-row-name">发票邮寄地址：</p>
            <p>{{invoiceInfo.emailAddress}}</p>
          </div>
        </div>
      </div>
      <div class="invoice-info-item" v-if="isDetails">
        <h3>发票信息</h3>
        <a-row class="invoice-info-row">
          <a-col :span="8">
            <p class="invoice-info-row-name">发票编码：</p>
            <p>{{currentInvoiceInfo.invoice_num}}</p>
          </a-col>
          <a-col :span="8">
            <p class="invoice-info-row-name">价税合计：</p>
            <p>{{currentInvoiceInfo.tax_amount}}</p>
          </a-col>
          <a-col :span="8">
            <p class="invoice-info-row-name">发票状态：</p>
            <p>{{status[currentInvoiceInfo.invoice_status]}}</p>
          </a-col>
          <a-col :span="8">
            <p class="invoice-info-row-name">申请时间：</p>
            <p>{{currentInvoiceInfo.create_time}}</p>
          </a-col>
          <a-col :span="8">
            <p class="invoice-info-row-name">发票类型：</p>
            <p>{{currentInvoiceInfo.invoice_type === 1 ? '增值税普通发票' : '增值税专用发票'}}</p>
          </a-col>
          <a-col :span="8">
            <p class="invoice-info-row-name">开票时间：</p>
            <p>{{currentInvoiceInfo.invoice_time || '暂未开具'}}</p>
          </a-col>
          <a-col :span="24">
            <p class="invoice-info-row-name">发票类目：</p>
            <p>{{(currentInvoiceInfo.invoiceType && currentInvoiceInfo.invoiceType.invoice_category.toString()) || '--'}}</p>
          </a-col>
          <!-- <a-col :span="24">
            <p class="invoice-info-row-name">查看发票：</p>
            <p @click="viewInvoice" class="view-invoice">查看发票</p>
          </a-col> -->
        </a-row>
      </div>
      <div class="invoice-info-item">
        <div v-if="!isDetails">
          <h3>票面信息</h3>
          <p class="invoice-item-remark">1.按充值金额，最大可开票金额：<span>{{invoiceData.amounting}}</span> 元 <br> 2.按实际发放，最大可开票金额：<span>{{invoiceData.amounting2}}</span> 元</p>
          <a-form-model ref="form" :model="invoiceFormData" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
            <a-row :gutter="0">
              <a-col :span="24">
                <a-col :span="12">
                  <a-form-model-item label="发票类型" prop="invoice_type">
                    <a-select placeholder="选择发票类型" v-model="invoiceFormData.invoice_type">
                      <a-select-option value="1">增值税普通发票</a-select-option>
                      <a-select-option value="2">增值税专用发票</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="发票类别" prop="invoice_class_1">
                  <a-select placeholder="选择发票类别" v-model="invoiceFormData.invoice_class_1">
                    <a-select-option v-for="(item, index) in invoiceContent.invoice_category" :key="index" :value="item">{{item}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="价税合计" prop="tax_amount_1">
                  <a-input-number :min="0" v-model="invoiceFormData.tax_amount_1" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="发票类别" prop="invoice_class_2">
                  <a-select placeholder="选择发票类别" v-model="invoiceFormData.invoice_class_2">
                    <a-select-option v-for="(item, index) in invoiceContent.invoice_category" :key="index" :value="item">{{item}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="价税合计" prop="tax_amount_2">
                  <a-input-number :min="0" v-model="invoiceFormData.tax_amount_2" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <div class="invoice-tips">
          <p>温馨提示：</p>
          <p>1、如选择按充值金额开票，剩余账户余额将不允许提现；</p>
          <p>2、增值税普通票不限制；</p>
          <p>3、增值税专用票限制规则：（1）开票金额大于等于20万开票不限制；（2）开票金额小于20万，限开票10次；</p>
          <p>如有疑问请联系专属客服。</p>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import SearchBox from '@/components/search-box/SearchBox.js'
import Card from '@/components/card/Card'
import { columnsInvoice, searchInvoice } from './columns'
import { invoiceList, invoiceExport, invoiceInfo, invoiceContentType, appInvoice, cancelInvoice } from '@/api/invoice'
import { PAGE_SIZE } from '@/config'
import { time2str } from '@/utils'

export default {
  data () {
    return {
      columns: columnsInvoice,
      searchData: searchInvoice,
      selectedRowKeys: [],
      loading: false,
      requestParams: {
        currentPage: 1,
        pagesize: PAGE_SIZE
      },
      status: {
        10: '待审核', 21: '已驳回', 22: '已取消', 30: '待开具', 40: '已开具', 50: '已邮寄', 61: '已作废', 62: '已红冲'
      },
      exportLoading: false,
      addLoading: false,
      isDetails: false,
      visible: false,
      invoiceInfo: {},
      invoiceContent: {},
      invoiceData: {},
      invoiceFormData: {
        invoice_type: '',
        invoice_class_1: '',
        invoice_class_2: '',
        tax_amount_1: '',
        tax_amount_2: ''
      },
      // rules: {
      //   invoice_type: [{ required: true, message: '发票类别不能为空', trigger: 'change' }],
      //   tax_amount_1: [{ required: true, message: '价税合计不能为空', trigger: 'blur' }],
      //   tax_amount_2: [{ required: true, message: '价税合计不能为空', trigger: 'blur' }],
      //   invoice_class_1: [{ required: true, message: '发票类目不能为空', trigger: 'change' }],
      //   invoice_class_2: [{ required: true, message: '发票类目不能为空', trigger: 'change' }]
      // },
      serachObj: {},
      currentInvoiceInfo: {}
    }
  },
  computed: {
    rules () {
      const rules = {
        invoice_type: [{ required: true, message: '发票类别不能为空', trigger: 'change' }],
        tax_amount_1: [{ required: true, message: '价税合计不能为空', trigger: 'blur' }],
        tax_amount_2: [{ required: true, message: '价税合计不能为空', trigger: 'blur' }],
        invoice_class_1: [{ required: true, message: '发票类目不能为空', trigger: 'change' }],
        invoice_class_2: [{ required: true, message: '发票类目不能为空', trigger: 'change' }]
      }

      const formData = this.invoiceFormData

      if (formData.tax_amount_1 !== '' && formData.invoice_class_1 !== '') {
        delete rules.tax_amount_2
        delete rules.invoice_class_2
      } else if (formData.tax_amount_2 !== '' && formData.invoice_class_2 !== '') {
        delete rules.tax_amount_1
        delete rules.invoice_class_1
      }

      return rules
    }
  },
  created () {
    this.getInvoiceList()

    invoiceInfo().then(response => {
      const { actionResult, data } = response
      if (actionResult === 1) {
        this.invoiceInfo = data
        this.getInvoiceContentType(response.extraData).then(data => {
          this.invoiceContent = data
        })
      }
    })
  },
  methods: {
    resetTables () {
      this.requestParams.currentPage = 1
      this.serachObj = {}
      this.getInvoiceList()
    },
    searchTableData (data) {
      const startTime = data.time ? time2str(data.time[0]) : ''
      const endTime = data.time ? time2str(data.time[1]) : ''

      this.serachObj = { ...data, startTime, endTime }
      this.getInvoiceList(this.serachObj)
    },
    onChange (v) {
      if (this.requestParams.currentPage === v) return
      this.requestParams.currentPage = v
      this.getInvoiceList(this.serachObj)
    },
    getInvoiceList (params = {}) {
      this.loading = true
      invoiceList({ ...this.requestParams, ...params }).then(response => {
        this.loading = false
        const { actionResult, data } = response

        if (actionResult === 1) {
          this.invoiceData = data
          this.data = data.infolist
          this.amounted = data.amounted
          this.amounting = data.amounting
          this.amounting2 = data.amounting2
        }
      }).catch(() => {
        this.loading = false
      })
    },
    invoiceExport () {
      this.exportLoading = true
      invoiceExport({ ...this.requestParams, ...this.serachObj }).then(response => {
        this.exportLoading = false
        const { actionResult, data } = response
        if (actionResult === '1') {
          window.open(data)
        }
      }).catch(() => {
        this.exportLoading = false
        this.$message.error('导出发票失败，请稍后再试！')
      })
    },
    // 申请开票
    applicInvoice () {
      this.isDetails = false
      this.visible = true
    },
    async viewDetails (data) {
      this.currentInvoiceInfo = data
      const invoiceType = await this.getInvoiceContentType(data.merchant_id)
      this.$set(this.currentInvoiceInfo, 'invoiceType', invoiceType)

      this.isDetails = true
      this.visible = true
    },
    getInvoiceContentType (id) {
      return new Promise((resolve, reject) => {
        invoiceContentType({ merchantid: id }).then(response => {
          const { actionResult, data, message } = response
          if (actionResult === 1) {
            resolve(data)
          } else {
            this.$message.error('获取发票类别失败，错误信息：' + message)
          }
        }).catch((err) => {
          reject(err)
          this.$message.error('获取发票类别失败！')
        })
      })
    },
    addAppInvoice () {
      if (!this.isDetails) {
        this.$refs.form.validate(valid => {
          if (valid) {
            const data = Object.assign({}, this.invoiceInfo)
            data.invoice_type = this.invoiceFormData.invoice_type

            let taxAmountArr = ''
            if (this.invoiceFormData.tax_amount_1 && this.invoiceFormData.tax_amount_2) {
              taxAmountArr = `[${this.invoiceFormData.tax_amount_1},${this.invoiceFormData.tax_amount_2}]`
            } else if (this.invoiceFormData.tax_amount_1) {
              taxAmountArr = `[${this.invoiceFormData.tax_amount_1}]`
            } else if (this.invoiceFormData.tax_amount_2) {
              taxAmountArr = `[${this.invoiceFormData.tax_amount_2}]`
            }

            let invoiceClass = ''
            if (this.invoiceFormData.invoice_class_1 && this.invoiceFormData.invoice_class_2) {
              invoiceClass = `["${this.invoiceFormData.invoice_class_1}","${this.invoiceFormData.invoice_class_2}"]`
            } else if (this.invoiceFormData.tax_amount_1) {
              invoiceClass = `["${this.invoiceFormData.invoice_class_1}"]`
            } else if (this.invoiceFormData.tax_amount_2) {
              invoiceClass = `["${this.invoiceFormData.invoice_class_2}"]`
            }

            data.tax_amount_arr = taxAmountArr
            data.invoice_class = invoiceClass
            data.tax_amount = 0

            // if (data) return
            this.addLoading = true

            appInvoice(data).then(response => {
              this.addLoading = false
              const { actionResult } = response
              if (actionResult === 1) {
                this.$message.success('申请发票成功！')
                this.getInvoiceList()
                this.visible = false
              } else {
                this.$message.error('申请发票失败，错误信息：' + response.message)
              }
            }).catch(() => {
              this.addLoading = false
              this.$message.error('申请发票失败！')
            })
          }
        })
      } else {
        const _this = this
        this.$confirm({
          title: '取消开票',
          content: '确定要取消开票？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            const { uid } = _this.currentInvoiceInfo
            cancelInvoice({ invoiceId: uid }).then(response => {
              const { actionResult, message } = response
              if (actionResult === 1) {
                _this.$message.success('取消开票成功！')
                _this.getInvoiceList(this.serachObj)
              } else {
                _this.$message.error('取消开票失败，错误信息：' + message)
              }
            }).catch(() => {
              _this.$message.error('取消开票失败!')
            })
          }
        })
      }
    },
    onCancel () {
      this.visible = false
      if (this.isDetails) return
      this.$refs.form.resetFields()
    },
    viewInvoice () {
      if (this.currentInvoiceInfo.invoice_time) {
        return
      }
      this.$message.info('发票暂未开具')
    }
  },
  components: { SearchBox, Card }
}
</script>

<style lang="scss">
.finance-invoice {
  .applic-btn {
    position: absolute;
    top: 18px;
    right: 20px;
  }

  .invoice-row {
    margin-bottom: 10px;
    padding: 20px;
    background: #fff;

    .ant-col + .ant-col {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
    }

    .invoice-row__item {
      display: flex;
      justify-content: center;

      & > div {
        display: flex;
        align-items: center;

        .item-icon {
          margin-right: 20px;

          & > i {
            font-size: 30px;
            color: #1890ff;
          }
        }

        .item-content {
          p + p {
            font-size: 28px;
            font-weight: bold;
            color: #1890ff;
          }
        }
      }
    }
  }
}

.invoice-info-item {
  .invoice-item-remark {
    margin: 10px 0;

    span {
      font-size: 20px;
      color: red;
    }
  }

  .info-item-content {
    margin-top: 15px;

    .content-row {
      display: flex;
      flex-direction: row;
      align-items: center;

      .content-row-name {
        font-weight: bold;
        width: 135px;
      }
    }

    .content-row + .content-row {
      margin-top: 10px;
    }
  }

  .invoice-info-row {
    margin-top: 5px;
    .ant-col {
      margin-top: 10px;
      display: flex;
      flex-direction: row;

      .invoice-info-row-name {
        width: 85px;
        font-weight: bold;
      }
    }
  }
}

.modal-okbtn[disabled] {
  color: rgba(0, 0, 0, 0.25) !important;
  span {
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

.view-invoice {
  color: #1890ff;
  cursor: pointer;

  &:active {
    color: #1890ff + 10;
  }
}

.invoice-info-item + .invoice-info-item {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
